
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'p-o-n-data/submissions', 'PONData', 'submissions')
        }

    },

    // Submissions scripts
    submissions:
    {

      // Method-wide scripts
      _init: function ()
      {

        APPLICATION._APPLICATION.processLinks('#submissions', 'PONData', 'submissions')

        // Get the development
        var development = $('#development_id')

        // On changing the company
        $('#company_id').not('.js-ignore').change(function ()
        {

          // Get the company ID
          var company_id = $(this).val()

          // If no brand or company
          if ('' === company_id)
          {
            development.next('.dropdown-menu').html('')
          }

          // Otherwise
          else
          {
            APPLICATION._APPLICATION.loadDropdown(development, APPLICATION._PATH_PREFIX + 'phase/dropdown-company/' + company_id + '?phase_id=' + development.val(), 'Phase', 'dropdownCompany')
          }

        }
        ).addClass('js-ignore').trigger('change')

        // On click export
        $('#export').not('.js-ignore').click(function ()
        {

          // The IDs
          var ids = []

          // Iterate over the checked IDs
          $('.js-service_ids:checked').each(function ()
          {
            ids.push($(this).val())
          }
          )

          // Download
          document.location.href = APPLICATION._PATH_PREFIX + 'p-o-n-data/export?service_ids=' + ids.join(',')

        }
        ).addClass('js-ignore')

      }

    },

    // Edit scripts
    edit:
    {
      // Method-wide scripts
      _init: function ()
      {
        APPLICATION.PONData.edit.calendar('edit')
      },

      calendar: function (action)
      {
        // On clicking the calendar
        $('#date_added_calendar').not('.js-ignore').click(function ()
        {
  
          // Get the form
          var form = $(this).closest('form').serialize()
  
          // Get the PON ID
          var pon_id = $(this).attr('data-' + APPLICATION._DATA_PREFIX + 'pon_id')
  
          // Store the datepicker
          APPLICATION._datepicker = function (date)
          {
  
            // Set the due date
            form += '&date_added=' + date
  
            // Show the custom modal
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'p-o-n-data/' + action + '/' + pon_id + '?' + form, 'PONData', action)
  
          }
  
          // Get the parts
          var parts = $('#date_added').val().split('/')
  
          // Open the calendar
          $('#calendar').data(APPLICATION._DATA_PREFIX + 'modal', APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0]).trigger('click')
  
        }
        ).addClass('js-ignore')

      }

    },

    // Search scripts
    missing:
    {
        // Method-wide scripts
        _init: function ()
        {
          APPLICATION._APPLICATION.load($('#submissions'), APPLICATION._PATH_PREFIX + 'p-o-n-data/missing-submissions', 'PONData', 'missingSubmissions')
        }

    },
  }